import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getRoutes } from "Router/getRoutes";
import { login, setAuthUser, setCurrentOrganization } from "Thunks";
import {
  selectUser,
  selectCurrentOrganization,
  selectRouting,
  selectLoggedAs
} from "Selectors";
import {
  getURLEmbeddedParam,
  getOrganizationIdParam,
  getAccessKeyParam,
  getURLWithoutHeaderParam,
  getURLParams
} from "Utils";
import { setAppIsEmbedded, setWithOutHeader, setBackOffice } from "Actions";
import { fetchFiduciaryData } from "Thunks";
import ScrollToTop from "Common/ScrollToTop";
import Layout from "Layout/Layout";
import SelectCommunity from "SelectCommunity/SelectCommunity";

import { ModeContext } from "Layout/Theme";
import NotFoundV2 from "./NotFound/NotFoundV2";
import { getCookie } from "Utils";
import { push } from "react-router-redux";
import { setPortail } from "../actions/actions";

export class App extends Component {
  state = {
    loaded: false,
    embedded: false,
    accessKey: null,
    notConnectedAccess: false,
    withoutHeader: false,
    didMount: false,
    queryToken: "",
    userId: null,
    organization_id: null,
    organizationIsSet: false,
    portal: null
  };

  static propTypes = {
    navCommunity: PropTypes.object,
    user: PropTypes.object,
    login: PropTypes.func.isRequired
  };

  componentWillMount() {
    const { location, routing, setWithOutHeader } = this.props;
    const { embedded } = getURLEmbeddedParam(location);
    const accessKey = getAccessKeyParam(location);
    let { withoutHeader } = getURLWithoutHeaderParam(location);
    const {
      uaWithoutHeader,
      queryToken,
      userId,
      organization_id,
      portal
    } = getURLParams(location);
    if (uaWithoutHeader) {
      withoutHeader = true;
    }
    this.setState({
      ...this.state,
      accessKey: accessKey,
      notConnectedAccess: /^\/presentation\//.test(routing.location.pathname),
      withoutHeader: withoutHeader,
      queryToken,
      userId,
      portal,
      organization_id
    });
    this.props.setPortail(portal);
    //  this.props.dispatch(setSwitchSpace(portal));
    setWithOutHeader(withoutHeader);

    if (embedded === "true") {
      this.props.setAppIsEmbedded(true);
    }

    if (getCookie(`BACK_OFFICE`) === "true") {
      this.props.setBackOffice(true);
    } else {
      this.props.setBackOffice(false);
    }
  }

  componentDidMount() {
    const { notConnectedAccess, accessKey, queryToken, userId } = this.state;
    // console.log(notConnectedAccess, accessKey);
    if (!notConnectedAccess || !accessKey) {
      // console.log("in", notConnectedAccess);
      if (queryToken && userId) {
        this.props.setAuthUser({
          token: queryToken,
          createdAt: Date.now(),
          expiresIn: 10000,
          id: userId
        });
      } else {
        this.props.login();
      }
    } else {
      // console.log("Removing Loader", notConnectedAccess);
      this.removeAppLoader();
    }
  }

  componentWillUnmount() {
    this.setState({
      ...this.state,
      didMount: false
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.user && this.props.user) {
      this.removeAppLoader();
    }
  }

  removeAppLoader = () => {
    $("#app-loader")
      .fadeOut()
      .promise()
      .done(() => $("#app-loader").remove());
  };

  handleGetRoutes = (currentOrganization, loggedAs, portail) => {
    return loggedAs === "GUEST" ? (
      <NotFoundV2
        errorPageType={"ACCESS_DENIED"}
        subText={"applicationNotActivated"}
        text={"applicationNotActivatedIndication"}
        buttonIgnored={true}
      />
    ) : (
      getRoutes(currentOrganization, this.props.backOffice, portail)
    );
  };

  render() {
    const { user, routing, loggedAs } = this.props;
    let { currentOrganization } = this.props;

    const {
      notConnectedAccess,
      accessKey,
      withoutHeader,
      didMount,
      organization_id,
      organizationIsSet,
      portal
    } = this.state;

    if (!notConnectedAccess || !accessKey) {
      if (!user) {
        return null;
      }

      //let id = getOrganizationIdParam(routing.location);
      if (organization_id && user.userOrganizations.length > 0) {
        let orgs = user.userOrganizations.filter(org => {
          // eslint-disable-next-line radix
          return parseInt(org.id) === parseInt(organization_id);
        });
        currentOrganization = orgs[0] || null;
        if (!organizationIsSet) {
          this.props.setCurrentOrganization(currentOrganization).then(() => {
            this.props.fiduciary();
          });
          this.setState({
            ...this.state,
            organizationIsSet: true
          });
        }
      }

      if (!didMount) {
        this.props.fiduciary();
        this.setState({
          ...this.state,
          didMount: true
        });
      }

      if (
        user &&
        !currentOrganization &&
        user.userOrganizations &&
        user.userOrganizations.length > 0
      ) {
        return <SelectCommunity />;
      }
    }

    return (
      <ScrollToTop location={routing.location}>
        {/^\/embed\//.test(routing.location.pathname) ? (
          <ModeContext.Provider value="embedded">
            {this.handleGetRoutes(currentOrganization, loggedAs, portal)}
          </ModeContext.Provider>
        ) : (
          <ModeContext.Provider value="full">
            <Layout
              withoutHeader={withoutHeader}
              notConnectedAccess={notConnectedAccess}
            >
              {this.handleGetRoutes(currentOrganization, loggedAs, portal)}
            </Layout>
          </ModeContext.Provider>
        )}
      </ScrollToTop>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  currentOrganization: selectCurrentOrganization(state),
  user: selectUser(state),
  loggedAs: selectLoggedAs(state),
  routing: selectRouting(state),
  backOffice: state.params.backOffice,
  portail: state.auth.portail
});

const mapDispatchToProps = dispatch => ({
  login: () => dispatch(login()),
  setAuthUser: authInfos => dispatch(setAuthUser(authInfos)),
  fiduciary: () => dispatch(fetchFiduciaryData()),
  setWithOutHeader: withoutHeader => dispatch(setWithOutHeader(withoutHeader)),
  setAppIsEmbedded: value => dispatch(setAppIsEmbedded(value)),
  setCurrentOrganization: currentOrg =>
    dispatch(setCurrentOrganization(currentOrg)),
  setBackOffice: value => dispatch(setBackOffice(value)),
  setPortail: value => dispatch(setPortail(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App.js